import styles from "./styles/select-voice-input-base.module.scss";
import Image from "next/image";
import addIcon from "@/assets/convert/add.svg";
import React from "react";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { ModalType } from "@/providers/modal-provider/modal-context.types";

export interface SelectVoiceInputProps {
  isEmptyVoiceFocused?: boolean;
  modalType: ModalType;
  isDisabled?: boolean;
  overriddenWrapperStyle?: string;
}

const SelectVoiceInputBase = ({
  isEmptyVoiceFocused,
  modalType,
  isDisabled,
  overriddenWrapperStyle,
}: SelectVoiceInputProps) => {
  const { showModal } = useGlobalModalContext();
  const showAllModelsModal = () => showModal(modalType);

  return (
    <div
      onClick={() => {
        if (isDisabled) {
          return;
        }
        showAllModelsModal();
      }}
      className={`${overriddenWrapperStyle ?? styles.empty_wrapper} ${isEmptyVoiceFocused && styles.focused_empty_wrapper}`}
    >
      <Image className={styles.add_icon} src={addIcon} alt="add" />
      <div className={styles.text_wrapper}>
        <div className={styles.select_voice_text}>Select a voice</div>
        <div className={styles.browse_text}>
          Browse thousands of royalty free voices
        </div>
      </div>
    </div>
  );
};

export default SelectVoiceInputBase;
